import InitiateDueDiligence from './InitiateDueDiligence';

export default InitiateDueDiligence;
